import { render } from "./CargosTable.vue?vue&type=template&id=9688de6c&scoped=true"
import script from "./CargosTable.vue?vue&type=script&lang=js"
export * from "./CargosTable.vue?vue&type=script&lang=js"

import "./CargosTable.vue?vue&type=style&index=0&id=9688de6c&scoped=true&lang=css"
import "./CargosTable.vue?vue&type=style&index=1&id=9688de6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9688de6c"]])

export default __exports__